import React from "react";
import "./TextError.styles.scss";

function TextError(props) {
  return (
    <p className="validation-error">
      <span>{props.children}</span>
    </p>
  );
}

export default TextError;
